import {
    WA_LOADING,
    WA_ERROR,
    GET_WA_OVERVIEW,
    GET_WA_JOURNEYS,
    GET_WA_MESSAGES,
    GET_WA_OFFERS,
    GET_WA_OFFERS_LIST,
    GET_WA_SUPPORT,
    GET_WA_SUPPORT_STATS,
    GET_WA_REASONS,
    GET_WA_TIMELINE
} from '../actions/types';

const emptyPage = { rows: [], total: 0, pages: 0, counts: {} };

const initialState = {
    loading: false,
    pending: {},
    errors: {},
    error: null,
    overview: null,
    journeys: null,
    messages: emptyPage,
    offers: null,
    offersList: emptyPage,
    support: emptyPage,
    supportStats: null,
    reasons: null,
    timeline: null
};

const DATASET_BY_TYPE = {
    [GET_WA_OVERVIEW]: 'overview',
    [GET_WA_JOURNEYS]: 'journeys',
    [GET_WA_OFFERS]: 'offers',
    [GET_WA_SUPPORT_STATS]: 'supportStats',
    [GET_WA_REASONS]: 'reasons',
    [GET_WA_TIMELINE]: 'timeline'
};

const PAGE_DATASET_BY_TYPE = {
    [GET_WA_MESSAGES]: 'messages',
    [GET_WA_OFFERS_LIST]: 'offersList',
    [GET_WA_SUPPORT]: 'support'
};

// `pending` and `errors` are keyed by the dataset action type so one request finishing never hides another's failure
const withoutKey = (map, key) => {
    const { [key]: removed, ...rest } = map;
    return rest;
};

const withErrors = (state, errors) => ({ ...state, errors, error: Object.values(errors)[0] || null });

const startPending = (state, key) => withErrors(
    { ...state, pending: { ...state.pending, [key]: true }, loading: true },
    withoutKey(state.errors, key)
);

const settlePending = (state, key) => {
    const pending = withoutKey(state.pending, key);
    return { ...state, pending, loading: Object.keys(pending).length > 0 };
};

export default function whatsappAnalyticsReducer(state = initialState, action) {
    const { type, payload, meta } = action;

    switch (type) {
        case WA_LOADING:
            return startPending(state, meta);

        case WA_ERROR:
            return withErrors(settlePending(state, meta), { ...state.errors, [meta]: payload });

        case GET_WA_MESSAGES:
        case GET_WA_OFFERS_LIST:
        case GET_WA_SUPPORT:
            return {
                ...settlePending(state, type),
                [PAGE_DATASET_BY_TYPE[type]]: {
                    rows: payload.rows || [],
                    total: payload.total || 0,
                    pages: payload.pages || 0,
                    counts: payload.counts || {}
                }
            };

        case GET_WA_OVERVIEW:
        case GET_WA_JOURNEYS:
        case GET_WA_OFFERS:
        case GET_WA_SUPPORT_STATS:
        case GET_WA_REASONS:
        case GET_WA_TIMELINE:
            return {
                ...settlePending(state, type),
                [DATASET_BY_TYPE[type]]: payload
            };

        default:
            return state;
    }
}
